import React from 'react';
import LegacyForm from './LegacyForm';
import Version2025 from './Version2025';

function NorthCarolinaForm(props) {
  const { version } = props;
  const isVersion2025OrLater = ['11_24'].includes(version);

  // 11_24 onwards
  if (isVersion2025OrLater) return <Version2025 {...props} />;

  return <LegacyForm {...props} />;
}

export default NorthCarolinaForm;
